const metaData = {
  fields: ['id', 'created_at', 'updated_at', 'question_id', 'option_details', 'paper_id'],
}

export default metaData
